module.exports = __webpack_public_path__ + "static/hyperv_42.73afbae9.png";